import React, { useState, useEffect, useCallback } from 'react'
import { TextField } from '@material-ui/core'
import { withFormsy } from 'formsy-react'
import _ from '@lodash'
import { useIntl, FormattedMessage } from 'react-intl'
import effects from 'app/effects/effects'
import clsx from 'clsx'
import * as R from 'ramda'
import { networkErrorToMessage } from 'commons/error'

const performCheckBeaconPhysicalAddress = _.debounce(
  async (
    physicalAddress,
    onValidating,
    onValidateComplete,
    onValidateError,
    disabled,
  ) => {
    if (!physicalAddress) return false
    onValidating()
    try {
      const result =
        await effects.apis.checkBeaconPhysicalAddress(physicalAddress)
      onValidateComplete(result)
    } catch (error) {
      onValidateError(error)
    }
  },
  500,
)

const MAX_LENGTH_BEACON_ID = 32
function BeaconIdInputFormsy(props) {
  const importedProps = _.pick(props, [
    'autoComplete',
    'autoFocus',
    'children',
    'className',
    'defaultValue',
    'disabled',
    'FormHelperTextProps',
    'fullWidth',
    'id',
    'InputLabelProps',
    'inputProps',
    'InputProps',
    'inputRef',
    'label',
    'multiline',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
    'placeholder',
    'required',
    'rows',
    'rowsMax',
    'select',
    'SelectProps',
    'type',
    'variant',
    'maxLength',
  ])

  const errorMessage = props.errorMessage
  const { onValidateComplete = () => {}, disabled } = props
  const callBackOnValidateComplete = useCallback(onValidateComplete, [])
  const value = props.value
  const { formatMessage } = useIntl()
  const label = R.unless(R.isNil, (id) => formatMessage({ id }), props.labelId)
  const placeholder = R.unless(
    R.isNil,
    (id) => formatMessage({ id }),
    props.placeholderId,
  )

  /* eslint-disable react-hooks/exhaustive-deps */
  const onInvalid = useCallback(
    R.compose(
      R.defaultTo(() => {}),
      R.prop('onInvalid'),
    )(props),
    [],
  )

  /* eslint-disable react-hooks/exhaustive-deps */
  const onValid = useCallback(
    R.compose(
      R.defaultTo(() => {}),
      R.prop('onValid'),
    )(props),
    [],
  )

  const [isValidating, setIsValidating] = useState(false)

  /* eslint-enable react-hooks/exhaustive-deps */
  const [checkBeaconPhysicalAddressError, setCheckBeaconPhysicalAddressError] =
    useState()

  useEffect(() => {
    if (!disabled) {
      performCheckBeaconPhysicalAddress(
        value,
        () => {
          setIsValidating(true)
          setCheckBeaconPhysicalAddressError(null)
          onInvalid()
        },
        (result) => {
          callBackOnValidateComplete(result)
          onValid()
          setIsValidating(false)
        },
        (error) => {
          const { message } = networkErrorToMessage(formatMessage)(error)
          setCheckBeaconPhysicalAddressError(message)
          onInvalid()
          setIsValidating(false)
        },
      )
    }
  }, [
    callBackOnValidateComplete,
    formatMessage,
    onInvalid,
    onValid,
    disabled,
    value,
  ])

  function changeValue(event) {
    const newValue = event.currentTarget.value

    props.setValue(newValue)

    if (props.onChange) {
      props.onChange(event)
    }
  }

  const checkingMessage = isValidating ? (
    <FormattedMessage id="emailInput.validating.label" />
  ) : null

  return (
    <div className={clsx('relative', props.containerClassName)}>
      <TextField
        {...importedProps}
        type="physicalAddress"
        onChange={changeValue}
        value={value}
        error={
          Boolean(errorMessage) ||
          Boolean(value && checkBeaconPhysicalAddressError)
        }
        helperText={
          errorMessage ||
          (value && checkBeaconPhysicalAddressError) ||
          checkingMessage
        }
        label={label}
        inputProps={R.mergeRight(props.inputProps, {
          maxLength: MAX_LENGTH_BEACON_ID,
        })}
        placeholder={placeholder}
      />
    </div>
  )
}

export default React.memo(withFormsy(BeaconIdInputFormsy))
